import dayjs from 'dayjs'

export function dateFormat(date: string) {
  return dayjs(date).format('YYYY-MM-DD')
}

export function timeFormat(date: string) {
  return dayjs(date).format('HH:mm')
}
